import React from 'react';
import { ModalWrapper } from './ModalWrapper';
import { POPUP_STYLES } from '../../constants/popupStyles';

interface MeetingCountModalProps {
    isOpen: boolean;
    onClose: () => void;
    caseManagerIntake: string;
    psychiatricIntake: string;
    psyFollowUp: string;
    caseManagerFollowUp: string;
}

export const MeetingCountModal: React.FC<MeetingCountModalProps> = ({
    isOpen,
    onClose,
    caseManagerIntake,
    psychiatricIntake,
    psyFollowUp,
    caseManagerFollowUp,
}) => {
    return (
        <ModalWrapper modalId="MeetingCountModal"
            isOpen={isOpen}
            onClose={onClose}
            title="Total Meetings"
        >
            {/* Content */}
            <div className="flex flex-col gap-4">
                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-[#366A75] min-w-[180px] text-left">
                        Case Manager Intake
                    </label>
                    <input
                        type="text"
                        value={caseManagerIntake}
                        readOnly
                        className={`flex-1 ${POPUP_STYLES.input}`}
                    />
                </div>

                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-[#366A75] min-w-[180px] text-left">
                        Psychiatric Intake
                    </label>
                    <input
                        type="text"
                        value={psychiatricIntake}
                        readOnly
                        className={`flex-1 ${POPUP_STYLES.input}`}
                    />
                </div>

                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-[#366A75] min-w-[180px] text-left">
                        CM Follow-Up
                    </label>
                    <input
                        type="text"
                        value={caseManagerFollowUp}
                        readOnly
                        className={`flex-1 ${POPUP_STYLES.input}`}
                    />
                </div>

                <div className="flex items-center gap-4">
                    <label className="text-sm font-medium text-[#366A75] min-w-[180px] text-left">
                        Psy Follow-Up
                    </label>
                    <input
                        type="text"
                        value={psyFollowUp}
                        readOnly
                        className={`flex-1 ${POPUP_STYLES.input}`}
                    />
                </div>
            </div>
        </ModalWrapper>
    );
};
